export default "__VITE_ASSET__DMJKImyR__"